(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lp-pro-aviso"] && !Shopify.designMode) return;
  try {
    /* Antes de la hora de corte (hora de Peru) muestra el titulo 'antes'; despues, el titulo 'despues'. */
  (function () {
    function apply(el) {
      var t = el.querySelector('[data-lpp-aviso-title]');
      if (!t) return;
      var cutoff = (parseInt(el.getAttribute('data-cutoff'), 10) || 15) * 3600;
      var lima = new Date(Date.now() - 5 * 3600000);
      var passed = lima.getUTCHours() * 3600 + lima.getUTCMinutes() * 60 + lima.getUTCSeconds();
      var want = passed < cutoff ? el.getAttribute('data-before') : el.getAttribute('data-after');
      if (want && t.textContent !== want) t.textContent = want;
    }
    function all() { document.querySelectorAll('[data-lpp-aviso]').forEach(apply); }
    function init() { all(); if (!window.__lppAvisoTimer) window.__lppAvisoTimer = setInterval(all, 30000); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lp-pro-hero"] && !Shopify.designMode) return;
  try {
    /* Aviso de urgencia: antes de la hora de corte (hora de Peru) muestra el texto 'antes';
     despues del corte, el texto 'despues', para no prometer un despacho que ya no sale hoy. */
  (function () {
    function apply(el) {
      var txt = el.querySelector('[data-lpp-note-text]');
      if (!txt) return;
      var cutoff = (parseInt(el.getAttribute('data-cutoff'), 10) || 15) * 3600;
      var lima = new Date(Date.now() - 5 * 3600000);
      var passed = lima.getUTCHours() * 3600 + lima.getUTCMinutes() * 60 + lima.getUTCSeconds();
      var want = passed < cutoff ? el.getAttribute('data-before') : el.getAttribute('data-after');
      if (want && txt.textContent !== want) txt.textContent = want;
    }
    function init() {
      var els = document.querySelectorAll('[data-lpp-note]');
      els.forEach(apply);
      if (!window.__lppNoteTimer) window.__lppNoteTimer = setInterval(function () { document.querySelectorAll('[data-lpp-note]').forEach(apply); }, 30000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lp-pro-packs"] && !Shopify.designMode) return;
  try {
    /* Al tocar un pack: lo marca, selecciona esa variante en el selector del tema (lo que usa el formulario
     contra entrega) y actualiza el precio de la cabecera. Al cargar, aplica SIEMPRE el pack marcado por
     defecto, aunque el enlace traiga ?variant= (asi el cliente ve primero el precio mas barato). */
  (function () {
    if (window.__lppPacksBound) return;
    window.__lppPacksBound = true;

    function selectPack(card) {
      var root = card.closest('[data-lpp-packs]');
      if (!root) return;

      root.querySelectorAll('.lpp-pack').forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var id = card.getAttribute('data-variant-id');
      var picker = document.querySelector('variant-picker[ref="mainVariantPicker"]') || document.querySelector('variant-picker');
      if (picker && id) {
        var input = picker.querySelector('input[type="radio"][data-variant-id="' + id + '"]');
        if (input) {
          if (!input.checked) input.click();
        } else {
          var opt = picker.querySelector('option[data-variant-id="' + id + '"]');
          if (opt) {
            var select = opt.closest('select');
            if (select.value !== opt.value) {
              select.value = opt.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }

      var hero = document.querySelector('[data-lpp-hero]');
      if (hero) {
        var price = hero.querySelector('[data-lpp-price]');
        var compare = hero.querySelector('[data-lpp-compare]');
        var save = hero.querySelector('[data-lpp-save]');
        var saveAmt = hero.querySelector('[data-lpp-save-amt]');
        var cmp = card.getAttribute('data-compare');
        var sv = card.getAttribute('data-save');
        if (price) price.textContent = card.getAttribute('data-price');
        if (compare) { compare.textContent = cmp; compare.hidden = !cmp; }
        if (save) save.hidden = !sv;
        if (saveAmt) saveAmt.textContent = sv;
      }
    }

    document.addEventListener('click', function (event) {
      var card = event.target.closest('.lpp-pack');
      if (!card || card.disabled) return;
      selectPack(card);
    });

    function applyDefault() {
      var root = document.querySelector('[data-lpp-packs][data-lpp-default]');
      if (!root) return;
      var card = root.querySelector('.lpp-pack.is-active');
      if (card && !card.disabled) selectPack(card);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(applyDefault, 0); });
    } else {
      setTimeout(applyDefault, 0);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
